import React from 'react';
import classNames from 'classnames/bind';
import CountUp from 'react-countup';
import styles from './Home.scss';
import { Dropdown, Button, Logo } from '../common';

import constants from '~/constants.js';
import { format } from '~/utils/FormatUtils.js';

const cx = classNames.bind(styles);

const Home = ({
  AgentsActions,
  section,
  sectionType,
  division,
  kic,
  numAgents,
  error,
}) => {
  const logo = (
    <div className={cx('home__logo')}>
      <Logo />
    </div>
  );

  const sectionDropdown = (
    <Dropdown
      value={section}
      onChange={v => AgentsActions.selectSection(v)}
      error={error}
    >
      <option value="" disabled>
        내 지역
      </option>
      {Object.keys(constants.sections).map(key => (
        <option key={key} value={key}>
          {constants.sections[key].name}
        </option>
      ))}
    </Dropdown>
  );

  let divisionDefaultString;
  if (sectionType === 'city') {
    divisionDefaultString = '전체 구';
  } else if (sectionType === 'district') {
    divisionDefaultString = '전체 시/군';
  } else {
    divisionDefaultString = '전체';
  }
  const divisionDropdown = section !== '' && (
    <Dropdown value={division} onChange={v => AgentsActions.selectDivision(v)}>
      <option value="all">{divisionDefaultString}</option>
      {constants.divisions[section].sort().map((sec, i) => (
        <option key={i} value={sec}>
          {sec}
        </option>
      ))}
    </Dropdown>
  );

  const kicDropdown = (
    <Dropdown value={kic} onChange={v => AgentsActions.selectKic(v)}>
      <option value="" disabled>
        내 업종
      </option>
      <option value="all">전체 업종</option>
      {constants.kics.map((ind, i) => (
        <option key={i} value={ind}>
          {ind}
        </option>
      ))}
    </Dropdown>
  );

  const dropdowns = (
    <div className={cx('home__dropdowns')}>
      {sectionDropdown}
      {divisionDropdown}
      {kicDropdown}
    </div>
  );

  const cta = (
    <div className={cx('home__cta')}>
      <Button
        block
        iconName="fa fa-chevron-right"
        iconAlign="right"
        onClick={() => AgentsActions.changeSearchFilter()}
      >
        맞춤 세무사 찾기
      </Button>
    </div>
  );

  const meta = (
    <div className={cx('home__meta')}>
      <CountUp
        className="u-text-important"
        start={4255}
        end={numAgents}
        duration={1}
        useEasing
        formattingFn={format}
      />
      개 캐시노트 고객사의
      <br />
      실제 세무대행 정보로 추천해드립니다.
    </div>
  );

  const partnerLink = (
    <div className={cx('home__partner-link')}>
      <i className="fa fa-shield" />
      <a href="https://advisors.cashnote.kr/">세무대리인 공식파트너 신청</a>
      <i className="fa fa-chevron-right" />
    </div>
  );

  return (
    <div className={cx('home')}>
      {logo}
      {dropdowns}
      {cta}
      {meta}
      {partnerLink}
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js